import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-outlined px-1 sm:px-2 pt-1 sm:pt-2" }
const _hoisted_2 = { class: "px-2 py-1 sm:p-4 mt-1 sm:mt-2 mb-1 sm:mb-2 mx-1 sm:mx-2" }
const _hoisted_3 = { class: "rounded p-2 sm:p-4 mt-1 sm:mt-2 mb-2 sm:mb-4 mx-1 sm:mx-2 bg-gray-50" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_alert = _resolveComponent("base-alert")!
  const _component_video_details_question_form = _resolveComponent("video-details-question-form")!
  const _component_video_details_question_messages = _resolveComponent("video-details-question-messages")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_alert, { class: "mb-4" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_video_details_question_form)
    ]),
    (Array.isArray(_ctx.videoQuestions))
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.videoQuestions, (videoQuestion) => {
          return (_openBlock(), _createElementBlock("div", {
            key: videoQuestion.id
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_video_details_question_messages, { videoQuestion: videoQuestion }, null, 8, ["videoQuestion"])
            ])
          ]))
        }), 128))
      : _createCommentVNode("", true)
  ]))
}